// extracted by mini-css-extract-plugin
export default {"question-or-option":"styles_question-or-option__BrLZA","or-option":"styles_or-option__1EQ+t"};